import { render, staticRenderFns } from "./XtendAlertsSentencesMetaData.vue?vue&type=template&id=0d50328e&"
import script from "./XtendAlertsSentencesMetaData.vue?vue&type=script&lang=js&"
export * from "./XtendAlertsSentencesMetaData.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports